import { Fragment } from "react";
import type { CrumbEntry, Route } from "../routing";

interface Props {
  crumbs: CrumbEntry[];
  onNav: (r: Route) => void;
  search: string;
  setSearch: (s: string) => void;
  partnerName: string;
  userName: string;
  userInitials: string;
  userRole: string;
  onLogout: () => void;
}

export function Topbar({
  crumbs,
  onNav,
  search,
  setSearch,
  partnerName,
  userName,
  userInitials,
  userRole,
  onLogout,
}: Props) {
  return (
    <header className="bbc-topbar">
      <div className="bbc-crumbs">
        {crumbs.map((c, i) => (
          <Fragment key={`${c.label}-${i}`}>
            {i > 0 && <span className="bbc-crumb-sep">/</span>}
            {c.route ? (
              <button
                type="button"
                className="bbc-crumb"
                onClick={() => onNav(c.route!)}
              >
                {c.label}
              </button>
            ) : (
              <span className="bbc-crumb is-current">{c.label}</span>
            )}
          </Fragment>
        ))}
      </div>

      <div className="bbc-topbar-right">
        <div className="bbc-search">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          >
            <circle cx="6" cy="6" r="4" />
            <path d="M9 9l3 3" />
          </svg>
          <input
            placeholder="Search subscriptions, users, services…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <kbd>⌘K</kbd>
        </div>
        <button
          className="bbc-icon-btn"
          type="button"
          aria-label="Notifications"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 7a4 4 0 1 1 8 0v3l1 1.5H3L4 10V7z" />
            <path d="M6.5 13a1.5 1.5 0 0 0 3 0" />
          </svg>
          <i className="bbc-dot" />
        </button>
        <div className="bbc-user">
          <span className="bbc-avatar">{userInitials}</span>
          <div className="bbc-user-meta">
            <div>{userName}</div>
            <div>
              {partnerName} · {userRole}
            </div>
            <button type="button" onClick={onLogout} aria-label="Sign out">
              Sign out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
